import { Link } from 'react-router-dom'

export default function RecentActivity({ activity, isLoading }) {
  const hasActivity = !isLoading && activity && activity.length > 0

  const getActivityDotClass = (status) => {
    if (status === 'completed') return 'success'
    if (status === 'pending') return 'warning'
    return 'info'
  }

  const getActivityStatusLabel = (status) => {
    if (status === 'completed') return 'Complété'
    if (status === 'pending') return 'En attente'
    return 'Actif'
  }

  return (
    <div className="activity-card">
      <div className="card-header">
        <h2>Activité récente</h2>
        <Link to="/dashboard/compte/activite" className="view-all-btn">
          Tout voir
        </Link>
      </div>
      <div className="activity-list-modern">
        {hasActivity ? (
          activity.map((item, i) => (
            <div key={i} className="activity-item-modern">
              <div className={`activity-dot ${getActivityDotClass(item.status)}`}></div>
              <div className="activity-details">
                <div className="activity-title">{item.title}</div>
                <div className="activity-meta">{item.meta}</div>
              </div>
              <div className={`activity-status ${item.status === 'completed' ? 'success' : ''}`}>
                {getActivityStatusLabel(item.status)}
              </div>
            </div>
          ))
        ) : (
          <div className="activity-item-modern">
            <div className="activity-dot info"></div>
            <div className="activity-details">
              <div className="activity-title">Aucune activité récente</div>
              <div className="activity-meta">Commencez par rechercher des prospects</div>
            </div>
            <div className="activity-status">-</div>
          </div>
        )}
      </div>
    </div>
  )
}
